import React from 'react'
import { withStyles, withTheme } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import { compose } from 'redux'
import MobileStepper from '@material-ui/core/MobileStepper'
import Button from '@material-ui/core/Button'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'

function StepNavFooter({
  classes,
  theme,
  translate,
  activeStep,
  maxSteps,
  loading,
  onBack,
  onNext
}) {
  const isSaveStep = activeStep === 3
  const isFirst = activeStep === 0
  const isLast = activeStep === maxSteps - 1
  const isRtl = theme.direction === 'rtl'

  return (
    <MobileStepper
      steps={maxSteps}
      position="static"
      activeStep={activeStep}
      className={classes.mobileStepper}
      backButton={
        <Button
          size="small"
          className={classes.buttonText}
          onClick={onBack}
          disabled={loading || isFirst || isLast}
        >
          {isRtl ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          {translate('previousLabel')}
        </Button>
      }
      nextButton={
        <Button
          size="small"
          className={classes.buttonText}
          onClick={onNext}
          disabled={loading || isLast}
        >
          {isSaveStep ? translate('saveLabel') : translate('nextLabel')}
          {isRtl ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </Button>
      }
    />
  )
}

const styles = () => ({
  buttonText: {
    fontSize: '11px'
  },
  mobileStepper: {
    marginTop: 20
  }
})

export default compose(
  withStyles(styles),
  withTheme
)(withTranslate(StepNavFooter))
